module.exports = __webpack_public_path__ + "static/media/do.344fe773.jpg";